import ReportsListing from 'vcomponents/pages/reports/ReportsListing.vue'
import Dashboard from 'vcomponents/pages/reports/cumulio/Dashboard.vue'
export default [
    {
        path: '/reports/all',
        name: 'reports.listing',
        component: ReportsListing
    },
    {
        path: '/reports/cumulio/:id',
        name: 'reports.cumulio',
        component: Dashboard,
        props: true
    },
    
]